/**
 * Types for the Purchase History proxy endpoint — `POST /api/v3/deal-pulse/purchase-history`.
 *
 * A separate file from `dealPulseData.ts` so `/api/v2/insights` shares no mutable type surface.
 */

/** Bounded outcome codes — safe to facet on in New Relic, never free-form text. */
export enum PurchaseHistoryProxyOutcome {
    ACCEPTED = 'accepted',
    /** Body was not parseable JSON, so it carried no identity. */
    MALFORMED_REQUEST = 'malformed_request',
    NO_CUSTOMER_IDENTIFIER = 'no_customer_identifier',
    NO_DEAL_IDENTIFIER = 'no_deal_identifier',
    NO_DEALER_IDENTIFIER = 'no_dealer_identifier',
    /** The service answered, but not with an acknowledgement. */
    DOWNSTREAM_FAILURE = 'downstream_failure',
    /** The service declined — e.g. a missing-identifier 204. */
    DOWNSTREAM_REFUSED = 'downstream_refused',
    DOWNSTREAM_TIMEOUT = 'downstream_timeout'
}

/** The request body. Every identifier is caller-supplied and used as given. */
export type PurchaseHistoryRequestBffData = {
    /** The warehouse's lookup key (`GLOBAL_CUSTOMER_ID`). */
    globalCustomerId: string;
    /** The deal the live push is addressed to. The service returns 204 without it. */
    dealId: string;
    dealerId: string;
    /** Clamped to 1-50 by the service; defaults to 10. */
    maxRecords?: number;
};

/** The acknowledgement. Carries an outcome only — never records, on any path. */
export type PurchaseHistoryAcknowledgementBffData = {
    ok: boolean;
    outcome: PurchaseHistoryProxyOutcome;
    correlationId: string;
};
